<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ partner.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PartnersTabLinks />
                    <CRow class="pl-3 pb-3" />

                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.title }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Юр. лицо</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.legal_entity }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">ИНН</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.individual_taxpayer_number }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Значения ставки НДС</CCol>
                        <CCol sm="9" class="col-form-label">{{ vat }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Использовать значения ставки НДС для каждого товара свою</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge
                                :color="getBadge(partner.use_product_vat)"
                            >&nbsp;{{ partner.use_product_vat ? "Да" : "Нет" }}&nbsp;</CBadge
                            >
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Способ оплаты</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            paymentTypeTitle(partner.payment)
                        }}</CCol>
                    </CRow>

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Признак способа расчета. Чек аванса</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            receiptMethod(partner.pre_receipt_method)
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Признак способа расчета. Финальный чек</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            receiptMethod(partner.final_receipt_method)
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Предмет расчета</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            receiptObject(partner.receipt_object)
                        }}</CCol>
                    </CRow>

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">№ договора</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.contract_id || '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Номер телефона партнера</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.phone || '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Дата договора</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.contract_date || '' }}</CCol>
                    </CRow>
                    <PartnerSigners :signers="partner.signers" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Комиссия МИРСИТИ (%)</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            partner.mircity_commission ? `${partner.mircity_commission}%` : ''
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Частота рассылки отчетов</CCol>
                        <CCol sm="9" class="col-form-label">{{ REPORT_FREQUENCY_TITLE[partner.report_frequency] }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Получатели отчетов</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.report_emails.join(', ') }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Телеграм чат</CCol>
                        <CCol sm="9" class="col-form-label">{{ partner.telegram_chat_id }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Используется телеграм бот</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge
                                :color="getBadge(partner.partnerTelegramUser)"
                            >&nbsp;{{ partner.partnerTelegramUser ? 'Да' : 'Нет' }}&nbsp;</CBadge
                            >
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Уведомлять о непринятых заказах</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge
                                :color="getBadge(partner.notification_delay && partner.try_count)"
                            >&nbsp;{{ partner.notification_delay && partner.try_count ? 'Да' : 'Нет' }}&nbsp;</CBadge
                            >
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Отключить применение тарифов по зонам</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge
                                :color="getBadge(partner.delivery_zone_disabled)"
                            >&nbsp;{{ partner.delivery_zone_disabled ? "Да" : "Нет" }}&nbsp;</CBadge
                            >
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge
                                :color="getBadge(partner.enabled)"
                            >&nbsp;{{ partner.enabled ? "Да" : "Нет" }}&nbsp;</CBadge
                            >
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Создан</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            formatDate(partner.created_at)
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Изменен</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            formatDate(partner.updated_at)
                        }}</CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnersTabLinks from '@/components/partner/PartnersTabLinks';
    import PartnerSigners from '@/components/partner/PartnerSigners';
    import { paymentTypeTitle } from '../../utils/payment-views';
    import { formatDate } from '../../utils/views';
    import { REPORT_FREQUENCY_TITLE } from '../../utils/partner';

    export default {

        name: 'Partner',
        components: {
            PartnersTabLinks,
            PartnerSigners,
        },

        data() {
            return {
                REPORT_FREQUENCY_TITLE,
                partner: {},
                vatOptions: [
                    { value: null, label: 'НДС не облагается' },
                    { value: 0, label: 'НДС 0%' },
                    { value: 5, label: 'НДС 5%' },
                    { value: 7, label: 'НДС 7%' },
                    { value: 10, label: 'НДС 10%' },
                    { value: 20, label: 'НДС 20%' },
                    { value: 22, label: 'НДС 22%' },
                    { value: 105, label: 'Расчетный НДС 5/105' },
                    { value: 107, label: 'Расчетный НДС 7/107' },
                    { value: 110, label: 'Расчетный НДС 10/110' },
                    { value: 120, label: 'Расчетный НДС 20/120' },
                    { value: 12, label: 'НДС 12% (только для онлайн-касс в Казахстане)' },
                ],
                receiptMethods: [
                    { value: 0, label: 'Unknown, неизвестный способ расчета' },
                    { value: 1, label: 'FullPrepayment, предоплата 100%' },
                    { value: 2, label: 'PartialPrepayment, предоплата' },
                    { value: 3, label: 'AdvancePay, аванс' },
                    { value: 4, label: 'FullPay, полный расчёт' },
                    { value: 5, label: 'PartialPayAndCredit, частичный расчёт и кредит' },
                    { value: 6, label: 'Credit, передача в кредит' },
                    { value: 7, label: 'CreditPayment, оплата кредита' },
                ],
                receiptObjects: [
                    { value: 0, label: 'Unknown, неизвестный предмет оплаты' },
                    { value: 1, label: 'Commodity, товар' },
                    { value: 2, label: 'ExcisedCommodity, подакцизный товар' },
                    { value: 3, label: 'Job, работа' },
                    { value: 4, label: 'Service, услуга' },
                    // { value: 5, label: 'GamblingBet, ставка азартной игры' },
                    // { value: 6, label: 'GamblingWin, выигрыш азартной игры' },
                    // { value: 7, label: 'LotteryTicket, лотерейный билет' },
                    // { value: 8, label: 'LotteryWin, выигрыш лотереи' },
                    // { value: 9, label: 'RidAccess, предоставление РИД' },
                    { value: 10, label: 'Payment, платеж' },
                    { value: 11, label: 'AgentReward, агентское вознаграждение' },
                    // { value: 12, label: 'Composite, Выплата' },
                    { value: 13, label: 'Another, иной предмет расчета' },
                    // { value: 14, label: 'PropertyLaw, Имущественное право' },
                    // { value: 15, label: 'NonOperatingIncome, Внереализационный доход' },
                    // { value: 16, label: 'InsuranceContributions, Страховые взносы' },
                    // { value: 17, label: 'TradeFee, Торговый сбор' },
                    // { value: 18, label: 'ResortFee, Курортный сбор' },
                    // { value: 19, label: 'CautionMoney, Залог' },
                    // { value: 20, label: 'ExpensesIncurred, Расход' },
                    // { value: 21, label: 'ContributionsOnIp, Взносы на обязательное пенсионное страхование ИП' },
                    // { value: 22, label: 'ContributionsSimple, Взносы на обязательное пенсионное страхование' },
                    // { value: 23, label: 'ContributionsMedical, Взносы на обязательное медицинское страхование ИП' },
                    // { value: 24, label: 'ContributionsMedicalSimple, Взносы на обязательное медицинское страхование' },
                    // { value: 25, label: 'ContributionsSocial, Взносы на обязательное социальное страхование' },
                    // { value: 26, label: 'CasinoPayment, Платеж казино' },
                    // { value: 27, label: 'CashWithdrawal, Выдача денежных средств (ффд 1.2)' },
                    // { value: 30, label: 'Atnm, АТНМ (ффд 1.2)' },
                    // { value: 31, label: 'Atm, АТМ (ффд 1.2)' },
                    // { value: 32, label: 'Tnm, ТНМ (ффд 1.2)' },
                    // { value: 33, label: 'Tm, ТМ (ффд 1.2)' },
                ]
            };
        },

        computed: {
            vat() {
                return this.vatOptions.find(item => item.value === this.partner.vat).label;
            }
        },

        mounted() {
            const id = this.$route.params.id;
            Vue.axios
                .get('/partners/' + id)
                .then(resp => {
                    this.partner = resp.data;
                    //this.$route.meta.label = this.partner.title;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            goBack() {
                this.$router.push({ path: '/partners' });
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            paymentTypeTitle(paymentTypeId) {
                return paymentTypeTitle(paymentTypeId);
            },
            receiptMethod(method) {
                return this.receiptMethods.find(item => item.value === method).label;
            },
            receiptObject(object) {
                return this.receiptObjects.find(item => item.value === object).label;
            },
            formatDate(date) {
                return formatDate(date);
            },
        },
    };
</script>
